import React, { useEffect } from 'react';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Footer from '../cards/Footer';
import { getMarkDown, useDetectMobile,useDetectIOS,useDetectAndroid } from '../utils';
import '../../../stylesheets/triagebot/Dialog.scss';

const ChangeOverDialog = ({ message, setShowChangeOverPromptDialog, isAccepted }) => {

    // const cancelButton = message?.data?.[1]?.changeoverPrompt?.data?.[0]?.cancelButton?.displayText
    // ? message.data[1].changeoverPrompt.data[0].cancelButton.displayText
    // : '';

    // const continueButton = message?.data?.[1]?.changeoverPrompt?.data?.[0]?.nextButton?.displayText
    // ? message.data[1].changeoverPrompt.data[0].nextButton.displayText
    // : '';

    const cancelButton = message?.data?.[0]?.cancelButton?.displayText
    ? message?.data?.[0].cancelButton.displayText
    : '';

    const continueButton = message?.data?.[0]?.nextButton.displayText
    ? message?.data?.[0].nextButton.displayText
    : '';

    const {isMobile} = useDetectMobile();
    const {isIOS} = useDetectIOS();
    const {isAndroid} = useDetectAndroid();
    const headerText = message?.data?.[0]?.headerText;
    const externalSchedulingUrl = message?.data?.[1]?.externalSchedulingUrl;
    const params = new URLSearchParams(new URL(externalSchedulingUrl).search);
    const isEVisit = params.has("csn")
    const csnValue = params.get("csn")
    const eVisitOdvvIOSUrl =isEVisit? message?.data?.[1]?.iOSEvisitURL?.replace('${csnValue}', csnValue): message?.data?.[1]?.iOSOdvvURL;
    const eVisitOdvvAndroidUrl = isEVisit ? message?.data?.[1]?.androidEVisitURL?.replace('${csnValue}', csnValue) : message?.data?.[1]?.androidOdvvURL;

    function getStyle(oElm, strCssRule) {
        var strValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if (oElm.currentStyle) {
            strCssRule = strCssRule.replace(/-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    useEffect(() => {
        setTimeout(() => {
            const cards = document.getElementsByClassName('turn');

            if (!cards.length) return;

            const cWidth = cards[cards.length - 1].offsetWidth;
            const dialog = document.querySelector('#change-dialog .MuiDialog-paper');

            if (!dialog) return;

            const padding = parseInt(getStyle(dialog, 'padding-left')) + parseInt(getStyle(dialog, 'padding-right'));

            dialog.style.width = (cWidth - padding) + 'px';
            dialog.style.minWidth = (cWidth - padding) + 'px';
        }, 1)
    })

    useEffect(() => {
        const element = document.getElementsByClassName('loader');
        if (element && element?.length > 0) {
            element[0].style.visibility = "hidden"; // Set visibility to hidden
        }
    }, [])

    const handleButtonEffect = () => { 
        setShowChangeOverPromptDialog(false);

        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    }

    const RedirectDeepLink = () => {
        if (isIOS && eVisitOdvvIOSUrl) {
            window.location.href = eVisitOdvvIOSUrl;
        }
        else if (isAndroid && eVisitOdvvAndroidUrl) {
            window.location.href = eVisitOdvvAndroidUrl;
        }
        else
        {
           window.open(`${externalSchedulingUrl}`);
        }         
        handleButtonEffect();
        isAccepted(true);
    }

    return (
        <Dialog
            id='change-dialog'
            open={true}
            onClose={handleButtonEffect}
        >
            <div id="dialog-title">
                <h2 className='headerText'>{getMarkDown(headerText)}</h2>
            </div>
            
            <DialogActions id="dialog-footer">
                <Footer>
                    <button
                        className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                        onClick={handleButtonEffect}
                    >
                       {cancelButton}
                    </button>
                    <button
                        className='continue-button'
                        onClick={RedirectDeepLink}
                    >
                        {continueButton}
                    </button>
                </Footer>
            </DialogActions>
        </Dialog>
    )
};

export default ChangeOverDialog;